import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { MyIntakePortal, RmsDataAccessObject } from '@safarilaw-webapp/feature/rms/data-access';
import { NavbarComponent } from '@safarilaw-webapp/shared/app-bootstrap/data-access';
import { DataAccessCallbacks, DataAccessService } from '@safarilaw-webapp/shared/redux';
import { SharedObservablesDirective } from '@safarilaw-webapp/shared/ui-kit/shared-observables-directive';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { Observable, map, mergeMap, of } from 'rxjs';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- ignore NG
  selector: 'sl-bootstrap-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, CollapseModule, AsyncPipe, SharedObservablesDirective]
})
export class RmsNavbarComponent extends NavbarComponent implements OnInit, DataAccessCallbacks {
  RmsObject: RmsDataAccessObject;
  recentIntakePortals$: Observable<MyIntakePortal[]>;
  public dataApi: DataAccessService;

  constructor() {
    super();

    this.RmsObject = this.inject(RmsDataAccessObject);
    const actions = this.inject(Actions);
    this.dataApi = new DataAccessService(this._store, actions, this);
  }

  onLoadObjectFail() {}
  onLoadObjectListFail() {}
  onDeleteObjectFail() {}
  onDeleteObjectSuccess() {}
  onCreateOrUpdateObjectFail() {}
  onCreateOrUpdateMultipleObjectsFail() {}
  onUpdateObjectListFail() {}

  ngOnInit(): void {
    super.ngOnInit();
    this.recentIntakePortals$ = this._authService.isAuthenticated$.pipe(
      mergeMap(isAuthenticated => {
        if (isAuthenticated) {
          return this.dataApi.loadObjectList$(this.RmsObject.MyIntakePortal);
        } else {
          return of({ items: [] as MyIntakePortal[] });
        }
      }),
      map(o => o.items)
    );
  }
}
